// extracted by mini-css-extract-plugin
export default {"profileContainer":"profile_profileContainer__lKtwL","profileTable":"profile_profileTable__fUEU4","editProfileBtn":"profile_editProfileBtn__1cNdD"};